import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css'; // Old CSS - commented out for new design system
import './styles/main.css'; // New StreamBuddy Design System
import App from './App';
import ExtensionInstallPage from './components/ExtensionInstallPage';
import { EXTENSION_PAGE_PATH } from './extensionInfo';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {window.location.pathname === EXTENSION_PAGE_PATH ? <ExtensionInstallPage /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
